export default __webpack_public_path__ + "static/media/senior-phone.b00536bb.jpeg";